import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m19.055 10.839-6.485 6.875c-.117.156-.312.195-.468.195a.59.59 0 0 1-.43-.156.58.58 0 0 1-.04-.86l5.47-5.859H2.375c-.352 0-.625-.273-.625-.586s.273-.664.625-.664h14.727l-5.47-5.82a.58.58 0 0 1 .04-.86c.273-.234.664-.234.898.04l6.485 6.875a.566.566 0 0 1 0 .82"
    }, null, -1)
  ])))
}
export default { render: render }